export enum AssetTypes {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}
